import { SocketEventHub } from '../../../components/sockets';
import {
  ReceiveSocketEvent,
  type ReceiveSocketEventPayloadMap,
  SendSocketEvent,
  type SendSocketEventPayloadMap,
} from './socketEvent.types';

const socketEventHub = new SocketEventHub<SendSocketEventPayloadMap, ReceiveSocketEventPayloadMap>([
  ReceiveSocketEvent.USER_PERMISSIONS_CHANGED,
]);

export default socketEventHub;
export { SendSocketEvent, ReceiveSocketEvent };
